import { Map } from 'immutable';
import Error403 from 'scenes/Errors/error403';
import Error404 from 'scenes/Errors/error404';
import Error500 from 'scenes/Errors/error500';
import Menu from 'scenes/Menu';
import UsersRights from 'scenes/UsersRights';

const userAgent = navigator.userAgent.toLowerCase();
const Login = userAgent.indexOf('electron') > -1 ? require('scenes/Login/electron') : require('scenes/Login/web');

export default new Map({
    '/login': {
        must_logged: false,
        must_not_logged: true,
        component: Login
    },
    // route http://localhost:3000 OU http://localhost:3000/ OU http://localhost:3000/menu
    '(/|/menu)': {
        must_logged: true,
        component: Menu
    },
    '/users_rights': {
        must_logged: true,
        admin: true,
        name: 'usersRights',
        component: UsersRights
    },
    '/error/403': {
        error: true,
        component: Error403
    },
    '/error/404': {
        error: true,
        component: Error404
    },
    '/error/500': {
        error: true,
        component: Error500
    }
});



// WEBPACK FOOTER //
// ./data/common/routes.js